/* Interior-page interactions: jump-nav scroll spy,
   composition index filter + detail dialog. Progressive:
   everything works as plain anchors/cards without this file. */

/* ————— Jump-nav scroll spy ————— */
const jump = document.querySelector('[data-jumpnav]');
if (jump) {
  const links = [...jump.querySelectorAll('a')];
  const map = new Map();
  links.forEach((a) => {
    const t = document.querySelector(a.getAttribute('href'));
    if (t) map.set(t, a);
  });
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          links.forEach((l) => l.classList.remove('is-active'));
          map.get(e.target)?.classList.add('is-active');
        }
      });
    },
    { rootMargin: '-40% 0px -55% 0px' }
  );
  map.forEach((_, t) => io.observe(t));
}

/* ————— Composition index: filter + dialog ————— */
const index = document.querySelector('[data-index]');
if (index) {
  const cards = [...index.querySelectorAll('.index-card')];

  /* Botanical index: open the full twenty on request, and never let a filter
     hide its own matches behind the fold. */
  const idxGrid = document.querySelector('[data-index]');
  const idxToggle = document.querySelector('[data-index-toggle]');
  const openIndex = () => {
    if (!idxGrid || !idxGrid.classList.contains('is-collapsed')) return;
    idxGrid.classList.remove('is-collapsed');
    if (idxToggle) {
      idxToggle.setAttribute('aria-expanded', 'true');
      idxToggle.textContent = 'Show fewer';
    }
  };
  if (idxGrid && idxToggle) {
    idxToggle.addEventListener('click', () => {
      const opening = idxGrid.classList.contains('is-collapsed');
      if (opening) { openIndex(); return; }
      idxGrid.classList.add('is-collapsed');
      idxToggle.setAttribute('aria-expanded', 'false');
      idxToggle.textContent = 'Show all twenty botanicals';
      idxGrid.closest('section').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  const filterWrap = document.querySelector('[data-filters]');

  if (filterWrap) {
    filterWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      filterWrap.querySelectorAll('button').forEach((b) => b.classList.toggle('is-on', b === btn));
      openIndex();
      const f = btn.dataset.filter;
      cards.forEach((c) => {
        const match = f === 'all' || (c.dataset.pillars || '').split(' ').includes(f);
        c.classList.toggle('is-dim', !match);
      });
    });
  }

  const dialog = document.querySelector('[data-index-dialog]');
  if (dialog && typeof dialog.showModal === 'function') {
    const img = dialog.querySelector('img');
    const latin = dialog.querySelector('.latin');
    const title = dialog.querySelector('h3');
    const inci = dialog.querySelector('.inci');
    const body = dialog.querySelector('[data-dialog-body]');
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const d = card.dataset;
        img.src = card.querySelector('img').src;
        img.alt = card.querySelector('img').alt;
        latin.textContent = d.latin || '';
        title.textContent = d.name || '';
        inci.textContent = d.inci || '';
        body.textContent = d.body || '';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      const r = dialog.querySelector('.index-dialog__grid').getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  }
}
